import { Component, OnInit } from '@angular/core';
import {
  BreadcrumbService,
  BreadcrumbItem,
} from '../../services/breadcrumb/breadcrumb.service';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
})
export class BreadcrumbComponent implements OnInit {
  breadcrumbs: BreadcrumbItem[] = [];

  constructor(private breadcrumbService: BreadcrumbService) {}

  ngOnInit(): void {
    // Inicializar breadcrumb do storage
    this.breadcrumbService.initializeBreadcrumb();

    // Subscrever às mudanças
    this.breadcrumbService.breadcrumbs$.subscribe((breadcrumbs) => {
      this.breadcrumbs = breadcrumbs;
    });
  }

  navigateToBreadcrumb(breadcrumb: BreadcrumbItem): void {
    // Só navegar se o item for clicável
    if (breadcrumb.clickable !== false) {
      this.breadcrumbService.navigateToBreadcrumb(breadcrumb);
    }
  }

  isLastBreadcrumb(breadcrumb: BreadcrumbItem): boolean {
    return this.breadcrumbs.indexOf(breadcrumb) === this.breadcrumbs.length - 1;
  }
}
